import axios from 'axios';

const request = axios.create({
    baseURL:  process.env.VUE_APP_BASE_API, // 所有请求的公共地址部分
    timeout: 15000 // 请求超时时间 这里的意思是当请求时间超过15秒还未取得结果时 提示用户请求超时
})

// 请求相关处理 请求拦截 在请求拦截中可以补充请求相关的配置
// interceptors axios的拦截器对象   config 请求的所有信息
request.interceptors.request.use(config => {
    // 请求头设置
    // config.headers.Authorization = token
    config.headers.version = "1.0.1";
    config.headers.oversea = localStorage.getItem('oversea') == '1' ? '1' : '0';
    config.headers.platform = sessionStorage.getItem('isiOS')==='true'?'ios':'android';
    config.headers.token = localStorage.getItem('token') || '';
    config.headers.sign = localStorage.getItem('sign') || '';
    config.headers.source = localStorage.getItem('source') || '1';    // w2传1  w3传2
    return config // 将配置完成的config对象返回出去 如果不返回 请求将不会进行
}, err => {
    // 请求发生错误时的相关处理 抛出错误
    Promise.reject(err)
})

request.interceptors.response.use(res => {
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    let data = res && res.data;
    //console.log('接口返回', res)
    if(data && data.success) {
        return Promise.resolve(data.data)
    } else {
        return Promise.reject(data)
    }
}, err => {
    //console.log('接口返回抛错', err)
    // 服务器响应发生错误时的处理
    if(err.code === "ECONNABORTED") {
        return Promise.reject(err)
    }
    else {
        return Promise.reject(err)
    }
})

export default request;

